import React from "react";
import { useTranslation } from "react-i18next";
import logoWhite from "../../images/logo.png";

const SIZES = {
  sm: "tw-w-12 tw-h-12 md:tw-w-14 md:tw-h-14",
  md: "tw-w-16 tw-h-16 md:tw-w-20 md:tw-h-20",
  lg: "tw-w-20 tw-h-20 md:tw-w-28 md:tw-h-28",
};

// The KinoKlik K already contains a right-pointing triangle, so the mark reads
// as a play affordance on its own. No separate triangle is drawn.
// Always the white mark: the disc stays dark in both themes because it sits on
// the video frame, and the purple mark disappears against it.
export default function PlayButtonK({ size = "md", onClick, className = "" }) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t("Play video")}
      className={`tw-group tw-rounded-full tw-flex tw-items-center tw-justify-center
        tw-border-solid tw-border-2 tw-border-[#ff43a7] tw-cursor-pointer tw-p-0 tw-bg-[#1E0039]/70 tw-backdrop-blur-sm
        tw-shadow-[0_0_24px_rgba(255,67,167,0.45)]
        hover:tw-bg-[#ff43a7]/25 hover:tw-shadow-[0_0_36px_rgba(255,67,167,0.75)]
        focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#ff43a7]
        tw-transition-all tw-duration-200 ${SIZES[size]} ${className}`}
    >
      <img
        src={logoWhite}
        alt=""
        aria-hidden="true"
        className="tw-w-1/2 tw-h-1/2 tw-object-contain tw-pointer-events-none
          group-hover:tw-scale-110 tw-transition-transform tw-duration-200"
      />
    </button>
  );
}
